import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import Layout from "src/features/Layout"
import Typography from "@material-ui/core/Typography"
import Grid from "@material-ui/core/Grid"
import Button from "@material-ui/core/Button"
import Box from "@material-ui/core/Box"
import Stepper from "@material-ui/core/Stepper"
import Step from "@material-ui/core/Step"
import StepLabel from "@material-ui/core/StepLabel"
import useNotification from "src/features/Notification/customs"
import { Form } from "react-final-form"
import { createBundle, clearMedicineBundle } from "./ducks"
import { push } from "redux-first-history"

import Step1 from "./Step1"
import Step2 from "./Step2"

function Index() {
  const dispatch = useDispatch()
  const { showError, showSuccess } = useNotification()

  const [step, setStep] = useState(1)
  const bundle_medicines = useSelector(
    (state) => state.bundle_create.bundle_medicines
  )

  const nextStep = () => {
    if (!bundle_medicines.length) {
      showError("กรุณาเลือกยาอย่างน้อย 1 ตัว")
    } else {
      setStep(2)
    }
  }

  const backStep = () => {
    setStep(1)
  }

  const calculatedTotalMedicinePrice = bundle_medicines.length
    ? bundle_medicines
        .map((item) =>
          item.is_promo
            ? item.promo_price * item.amount
            : item.price * item.amount
        )
        .reduce((acc, crv) => acc + crv)
    : 0

  // Waiting for create with supply later

  // const calculatedTotalSupplyPrice = get(detail, "supply", []).length
  //   ? get(detail, "supply", [])
  //       .map((item) => (item.is_promo ? item.promo_price * item.amount  : item.price * item.amount ))
  //       .reduce((acc, crv) => acc + crv)
  //   : 0

  const total_price = calculatedTotalMedicinePrice

  // clear selected list
  useEffect(() => {
    return () => {
      dispatch(clearMedicineBundle())
    }
  }, [])

  return (
    <Form
      initialValues={{
        name: "",
        promo_price: "",
        detail: "",
        active: true,
        supply: [],
        medicine: bundle_medicines,
        cover_img: "",
      }}
      onSubmit={async (values) => {
        try {
          if (values.promo_price >= total_price) {
            showError("Bundle price must not be lower than total price.")
          } else {
            await dispatch(
              createBundle({
                ...values,
                promo_price: parseInt(values.promo_price),
                medicine: values.medicine.map((item) => ({
                  _id: item._id,
                  amount: item.amount,
                })),
              })
            )
            dispatch(push("/bundle"))
            showSuccess()
          }
        } catch (error) {
          showError()
        }
      }}
      mutators={{
        setImg: (args, state, utils) => {
          utils.changeValue(state, "cover_img", () => args[0])
        },
      }}
      subscription={{ values: true, submitting: true }}
    >
      {({ handleSubmit }) => (
        <Layout
          breadcrumbs={{
            previous: [{ href: "/bundle", name: "List" }],
            current: "Create",
          }}
        >
          <Typography variant="h5" gutterBottom>
            Create New Bundle
          </Typography>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={8}>
              <Stepper activeStep={step - 1}>
                <Step>
                  <StepLabel>Choose Package</StepLabel>
                </Step>
                <Step>
                  <StepLabel>Bundle Description</StepLabel>
                </Step>
              </Stepper>
            </Grid>
            <Grid item xs={12} sm={4} align="right">
              {step === 1 && (
                <Button
                  variant="contained"
                  size="large"
                  disableElevation
                  color="secondary"
                  onClick={nextStep}
                >
                  next
                </Button>
              )}
              {step === 2 && (
                <>
                  <Box
                    component={Button}
                    variant="contained"
                    size="large"
                    disableElevation
                    onClick={backStep}
                    mr={2}
                  >
                    back
                  </Box>
                  <Button
                    variant="contained"
                    size="large"
                    disableElevation
                    color="secondary"
                    onClick={handleSubmit}
                  >
                    Create Bundle
                  </Button>
                </>
              )}
            </Grid>
          </Grid>
          {step === 1 && <Step1 />}
          {step === 2 && <Step2 totalPrice={total_price} />}
        </Layout>
      )}
    </Form>
  )
}

export default Index
